import { render } from "./CommercialBanner.vue?vue&type=template&id=6c0595e6&scoped=true&ts=true"
import script from "./CommercialBanner.vue?vue&type=script&lang=ts"
export * from "./CommercialBanner.vue?vue&type=script&lang=ts"

import "./CommercialBanner.vue?vue&type=style&index=0&id=6c0595e6&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\98\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0595e6"]])

export default __exports__